import { ICellEditorParams } from "ag-grid-community";
import { useEffect, useRef, useState } from "react";

export default function ReceivablesEditor(props: ICellEditorParams) {
  const { data, api, context } = props;
  const [receivables, setReceivables] = useState(
    data?.receivables?.column_value || ""
  );
  const [receivablesStatus, setReceivablesStatus] = useState(
    data?.receivables_status?.column_value || ""
  );

  const wrapperRef = useRef<HTMLDivElement>(null);

  const handleBlur = (e: FocusEvent) => {
    if (!wrapperRef.current) return;
    // if the new focused element is inside our editor, don't save yet
    if (wrapperRef.current.contains(e.relatedTarget as Node)) return;
    saveChanges();
  };

  const handleKeyDown = (e: KeyboardEvent) => {
    if (e.key === "Enter") {
      saveChanges();
    }
  };

  useEffect(() => {
    const node = wrapperRef.current;
    node?.addEventListener("keydown", handleKeyDown);
    node?.addEventListener("focusout", handleBlur);
    return () => {
      node?.removeEventListener("keydown", handleKeyDown);
      node?.removeEventListener("focusout", handleBlur);
    };
  }, [receivables, receivablesStatus]);

  const saveChanges = () => {
    data.receivables.column_value = receivables;
    data.receivables_status.column_value = receivablesStatus;
    api.applyTransaction({ update: [data] }); // update row

    context?.handleSave?.();
  };

  return (
    <div className="flex" ref={wrapperRef}>
      <input
        type="number"
        placeholder="Enter"
        value={receivables}
        onChange={(e) => setReceivables(e.target.value)}
        className="w-full pl-2 outline-none"
        autoFocus
      />
      <select
        value={receivablesStatus}
        onChange={(e) => setReceivablesStatus(e.target.value)}
        className="w-full outline-none"
      >
        <option value="" disabled className="text-gray-400">
          Select status
        </option>
        <option value="Pending">Pending</option>
        <option value="Paid">Paid</option>
      </select>
    </div>
  );
}
